export const buildFilterList = (items, type) => {
  // Build the filter list for the dropdown safely
  if (!items || !Array.isArray(items)) return [];
  return items.map(item => ({
    id: item.id,
    name: type === 'labels' ? item.title : item.name,
    type,
  }));
};

export const getActiveFilter = (filters, type, key) => {
  // Method is used to get the active filter from the filter list safely
  if (
    !filters ||
    !Array.isArray(filters) ||
    key === undefined ||
    key === null
  ) {
    return { id: '', name: '', title: '' };
  }
  const found = filters.find(filterItem =>
    type === 'labels'
      ? filterItem && filterItem.title === key
      : filterItem &&
        filterItem.id &&
        filterItem.id.toString() === key.toString()
  );
  return found || { id: '', name: '', title: '' };
};

export const getFilterType = (input, direction) => {
  // Method is used to map the filter key to the filter type
  const filterMap = {
    keyToType: {
      assigned_agent_id: 'agents',
      inbox_id: 'inboxes',
      team_id: 'teams',
      sla_policy_id: 'sla',
      label_list: 'labels',
      event_type: 'infractions',
    },
    typeToKey: {
      agents: 'assigned_agent_id',
      inboxes: 'inbox_id',
      teams: 'team_id',
      sla: 'sla_policy_id',
      labels: 'label_list',
      infractions: 'event_type',
    },
  };
  return filterMap[direction][input];
};
